import component from "containers/StaticPages/pages/SellerSignup";

export default {
  key: "seller-signup",
  title: "Seller Signup",
  path: "/:user?/signup/:slug?",
  pageName: "signup",
  linkTarget: "/signup",
  component,
};
